// @ts-nocheck
import React from 'react';

const SIZES = {
  sm: 'px-2.5 py-1.5 text-[12px] rounded-lg2',
  md: 'px-3.5 py-2 text-[13px] rounded-md2',
  lg: 'px-4 py-3 text-[14px] rounded-md2',
};

const VARIANTS = {
  default: 'mov-btn-default border border-mov-line-strong bg-mov-paper text-mov-ink',
  primary: 'mov-btn-primary',
  accent: 'mov-btn-accent border border-mov-green',
  'accent-soft': 'border border-transparent bg-mov-green-soft text-mov-green-ink mov-btn-accent-soft',
  ghost: 'border border-transparent bg-transparent text-mov-ink-soft hover:bg-mov-paper-2 hover:border-mov-line hover:text-mov-ink',
  outline: 'border border-mov-line-strong bg-transparent text-mov-ink mov-btn-default',
  danger: 'mov-btn-danger border border-mov-danger text-white',
};

const Spinner = () => <span aria-hidden="true" className="mov-spinner" />;

/**
 * Button — the only button primitive we ship. Pick a variant + size; pass
 * `icon` for a leading icon, `iconRight` for a trailing one. `loading` shows
 * a spinner and disables the button.
 */
const Button = React.forwardRef(({
  variant = 'default',
  size = 'md',
  type = 'button',
  icon: Icon,
  iconRight: IconRight,
  loading,
  disabled,
  className = '',
  children,
  ...rest
}, ref) => {
  const cls = [
    'inline-flex items-center justify-center gap-2 font-medium leading-none',
    'transition-colors duration-150 outline-none mov-focus-ring',
    'disabled:opacity-45 disabled:cursor-not-allowed',
    SIZES[size],
    VARIANTS[variant],
    className,
  ].join(' ');

  return (
    <button ref={ref} type={type} className={cls} disabled={disabled || loading} {...rest}>
      {loading ? <Spinner /> : Icon ? <Icon size={size === 'sm' ? 13 : 14} /> : null}
      {children && <span className="leading-none">{children}</span>}
      {!loading && IconRight && <IconRight size={size === 'sm' ? 13 : 14} />}
    </button>
  );
});
Button.displayName = 'Button';

export default Button;
